/*globals $ */

class Sticky {
  constructor(mainApp) {
    this.mainApp      = mainApp;
    this.$container   = $('.Sticky');
    this.$inner       = this.$container.find('.Sticky__inner');
    this.$content     = this.$container.find('.StickyContent');
    this.hideContent  = false;
    this.prevScrollTop = 0;//scrollTop;
    this.scrollDiff   = 0;


    this.type         = this.$container.attr('data-type');

    // if(this.type == 'product-detail') {
      this.hideContent = true;
      this.$inner.css('bottom', -this.$content.outerHeight());
    // }
  }



  onWindowScroll(scrollTop) {
    if(scrollTop < 0) scrollTop = 0;

    if(scrollTop != this.prevScrollTop) {
      if(scrollTop > this.prevScrollTop) {
        this.scrollDiff = 1;
      } else {
        this.scrollDiff = -1;
      }
    }

    let isShowSticky = true;
    if(this.type == 'product-detail') {
      /*
      if(
        scrollTop + this.mainApp.windowHeight > $('.ContentSwitcherHeight').offset()['top'] + 110
        && scrollTop < $('.ProductDetailBottom').offset()['top'] - this.mainApp.windowHeight
      ) {
        if(scrollTop < this.prevScrollTop) {
          if(this.hideContent) {
            this.hideContent = false;
            this.$inner.css('bottom', 0);
          }
        } else {
          if(!this.hideContent) {
            this.hideContent = true;
            this.$inner.css('bottom', -this.$content.outerHeight() - 30);
          }
        }
      } else {
        if(!this.hideContent) {
          this.hideContent = true;
          this.$inner.css('bottom', -this.$content.outerHeight() - 30);
        }
      }
      */

      if(scrollTop == this.prevScrollTop) {
        if(this.scrollDiff == 1) {
          isShowSticky = false;
        }
      } else if(scrollTop > this.prevScrollTop) {
        isShowSticky = false;
      }

      // フッターが表示されているかどうか
      if(scrollTop + this.mainApp.windowHeight >= $('.Footer').offset()['top']) {
        isShowSticky = false;
      }

      if(isShowSticky) {
        if(this.hideContent) {
          this.hideContent = false;
          this.$inner.css('bottom', 0);
        }
      } else {
        if(!this.hideContent) {
          this.hideContent = true;
          this.$inner.css('bottom', -this.$content.outerHeight() - 30);
        }
      }


    } else if(this.type == 'top') {

      // 一番上の"ログイン・ご注文"ボタンが画面内かどうか
      /*
      if(
        scrollTop + this.mainApp.windowHeight >= $('.BtnBlock--top-primary').offset()['top']
        && scrollTop < $('.BtnBlock--top-primary').offset()['top'] + $('.BtnBlock--top-primary').height()
      ) {
        isShowSticky = false;
      } else {
        if(scrollTop + this.mainApp.windowHeight > $('.BtnBlock--top-primary').offset()['top']) {
          if(scrollTop > this.prevScrollTop) {
            isShowSticky = false;
          }
        }
      }
      */


      if(scrollTop == this.prevScrollTop) {
        if(this.scrollDiff == 1) {
          isShowSticky = false;
        }
      } else if(scrollTop > this.prevScrollTop) {
        isShowSticky = false;
      }

      // フッターが表示されているかどうか
      if(scrollTop + this.mainApp.windowHeight >= $('.Footer').offset()['top']) {
        isShowSticky = false;
      }

      if(isShowSticky) {
        if(this.hideContent) {
          this.hideContent = false;
          this.$inner.css('bottom', 0);
        }
      } else {
        if(!this.hideContent) {
          this.hideContent = true;
          this.$inner.css('bottom', -this.$content.outerHeight() - 30);
        }
      }

      /*
      if(scrollTop + this.mainApp.windowHeight >= $('.Footer').offset()['top']) {
        if(!this.hideContent) {
          this.hideContent = true;
          this.$inner.css('bottom', -this.$content.outerHeight() - 30);
        }
      } else {
        if(this.hideContent) {
          this.hideContent = false;
          this.$inner.css('bottom', 0);
        }
      }
      */
    }

    this.prevScrollTop = scrollTop;
  }
}

export default Sticky;
